import { useState } from "react";
import { Info } from "lucide-react";

const CONFIDENCE_MAP = {
    high: { color: "var(--brand-success)", label: "High confidence", dot: "🟢" },
    medium: { color: "var(--brand-warning)", label: "Medium confidence", dot: "🟡" },
    low: { color: "var(--brand-red)", label: "Low confidence — ambiguous", dot: "🔴" },
    manual: { color: "var(--brand-text-muted)", label: "Manual entry", dot: "⚪" },
};

export function ConfidenceBadge({ confidence }) {
    const cfg = CONFIDENCE_MAP[confidence] || CONFIDENCE_MAP.manual;
    return (
        <span
            className="inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded-full"
            style={{
                background: "rgba(0,0,0,0.04)",
                color: cfg.color,
                border: `1px solid ${cfg.color}40`,
            }}
            title={cfg.label}
            data-testid={`confidence-badge-${confidence || "manual"}`}
        >
            <span aria-hidden="true">{cfg.dot}</span>
            <span className="capitalize">{confidence || "manual"}</span>
        </span>
    );
}

export function SourceBadge({ source, ambiguous = [] }) {
    const [open, setOpen] = useState(false);
    if (!source) return null;
    return (
        <span className="relative inline-block ml-2">
            <button
                type="button"
                onMouseEnter={() => setOpen(true)}
                onMouseLeave={() => setOpen(false)}
                onFocus={() => setOpen(true)}
                onBlur={() => setOpen(false)}
                className="inline-flex items-center justify-center w-5 h-5 rounded-full"
                style={{
                    background: "rgba(237,108,2,0.12)",
                    color: "var(--brand-warning)",
                }}
                aria-label="Source attribution"
                data-testid="source-badge"
            >
                <Info size={11} />
            </button>
            {open && (
                <span
                    className="absolute z-20 top-6 left-0 min-w-[220px] text-xs px-3 py-2 rounded-md shadow-lg"
                    style={{
                        background: "var(--brand-bg, #fff)",
                        border: "1px solid rgba(0,0,0,0.1)",
                        color: "var(--brand-text)",
                    }}
                    role="tooltip"
                >
                    <span className="block font-semibold">Source</span>
                    <span className="block mt-1">
                        Section <strong>{source.section}</strong>
                        {source.title ? ` · ${source.title}` : ""}
                    </span>
                    <span className="block text-muted">Page {source.page || "—"}</span>
                    {ambiguous.length > 0 && (
                        <span className="block mt-2 pt-2 border-t">
                            <span className="block font-semibold">Alternates</span>
                            {ambiguous.map((a, i) => (
                                <span key={i} className="block">
                                    · {a}
                                </span>
                            ))}
                        </span>
                    )}
                </span>
            )}
        </span>
    );
}
